"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PluginHint = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Errors_1 = require("../../Errors");

var NoPluginHint_1 = require("./NoPluginHint");

var NotTrustedHost_1 = require("./NotTrustedHost");

var Sticky_1 = require("@skbkontur/react-ui/components/Sticky");

var configuration_1 = require("../../../contexts/configuration");

exports.PluginHint = function (_a) {
  var errorCode = _a.errorCode;
  return react_1.default.createElement(configuration_1.WithConfiguration, null, function (_a) {
    var addToTrustedLink = _a.addToTrustedLink;
    var component;

    switch (errorCode) {
      case Errors_1.DisplayedErrorCodes.NoPlugin:
        component = react_1.default.createElement(NoPluginHint_1.NoPluginHint, null);
        break;

      case Errors_1.DisplayedErrorCodes.NotTrustedHost:
        component = react_1.default.createElement(NotTrustedHost_1.NotTrustedHost, {
          addToTrustedLink: addToTrustedLink
        });
        break;

      default:
        return null;
    }

    return react_1.default.createElement(Sticky_1.Sticky, {
      side: "bottom"
    }, component);
  });
};